<template>
  <Layout
    :errors="errors"
    :title="trans(`models.${resourceType}.content.create.action`)"
    :toasts="toasts"
    :resource="model"
  >
    <div v-if="model.data" class="card rounded-corner">
      <div class="card-body">
        <div class="model-title-bar">
          <h5 class="card-title text-primary fw-bold text-uppercase">
            {{ trans(`models.${resourceType}.content.create.action`) }}
          </h5>
        </div>
        <p class="card-text">
          {{ trans(`models.${resourceType}.content.create.description`) }}
        </p>
        <resource-form :errors="errors" :resource="model"></resource-form>
      </div>
    </div>
  </Layout>
</template>

<script>
import ResourceForm from '@/structures/default/components/ResourceForm';
import Layout from '@/structures/moviary/Pages/Layout';
import useResource from '@/structures/default/composables/useResource';

export default {
  components: {
    Layout,
    ResourceForm,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    model: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
  },
  setup(props) {
    const { resourceType } = useResource(props, props.model);

    return {
      resourceType,
    };
  },
};
</script>
